module.exports = __webpack_public_path__ + "img/spain.75faaf4d.svg";